import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import {
  pendingUploadsSelector,
  currentBoardSelector,
  currentBlockSelector
} from '../../../store/selectors/selectors'
import { getFoldersSelector } from '../../../store/selectors/accessSelectors'
import { boardWidthSelector } from '../../../store/selectors/boardSelectors'
import getUrl from '../../../utils/getUrl'
import { sidebarShowingSelector } from '../../../store/selectors/sidebarSelectors';
import { userSelector } from '../../../store/selectors/baseSelectors';

export default connect(
  (state, props) => {
    const board = currentBoardSelector(state)
    const folders = getFoldersSelector(state)(board)
    return {
      board,
      folders,
      anon: userSelector(state).isAnonymous,
      block: currentBlockSelector(state),
      boardWidth: boardWidthSelector(state),
      pendingUploads: pendingUploadsSelector(state),
      minimal: props.minimal || sidebarShowingSelector(state)
    }
  },
  dispatch => ({
    goToFolder: folder => dispatch(push(getUrl({ ...folder, type: 'folder' })))
  })
)
